import { Controller } from 'stimulus';

// Store previous content globally so undo can access it
// even when the populate controller instance is different
window.quickstartPreviousContent = null

export default class extends Controller {
  static targets = ['content']

  connect() {
    console.log('[populate-document] Controller connected')
    // Auto-populate on connect if we have content target
    if (this.hasContentTarget) {
      console.log('[populate-document] Has content target, calling populateDocument')
      this.populateDocument()
    } else {
      console.log('[populate-document] No content target found')
    }
  }

  populateDocument() {
    // Store previous content for undo (globally accessible)
    // Skip if already stored during streaming
    if (!window.quickstartPreviousContent) {
      this.storePreviousContent()
    }

    // Get the response content
    const container = this.contentTarget
    console.log('[populate-document] Container:', container)
    console.log('[populate-document] Container innerHTML:', container.innerHTML)

    const dataElements = container.querySelectorAll('[data_target]')
    console.log('[populate-document] Found data elements:', dataElements.length)

    // Populate each field
    dataElements.forEach((element) => {
      const targetName = element.getAttribute('data_target')
      console.log('[populate-document] Populating field:', targetName)
      this.populateField(targetName, element.innerHTML.trim())
    })
  }

  storePreviousContent() {
    const previousContent = {
      title: '',
      description: '',
      body: ''
    }

    // Store title
    const titleField = document.getElementById('post_title')
    if (titleField) {
      previousContent.title = titleField.value || ''
    }

    // Store description
    const descriptionField = document.getElementById('post_description')
    if (descriptionField) {
      previousContent.description = descriptionField.value || ''
    }

    // Store body
    if (window.tiptapEditor) {
      previousContent.body = window.tiptapEditor.getHTML() || ''
    } else {
      const editorField = document.querySelector('.editable')
      if (editorField) {
        previousContent.body = editorField.innerHTML || ''
      }
    }

    window.quickstartPreviousContent = previousContent
  }

  populateField(targetName, content) {
    console.log('[populate-document] populateField called with:', targetName, 'content length:', content.length)

    if (targetName === 'editable') {
      if (window.tiptapEditor) {
        window.tiptapEditor.commands.setContent(content)
        if (window._syncAndSaveEditor) window._syncAndSaveEditor()
        console.log('[populate-document] Body content set via Tiptap')
      } else {
        const editorField = document.querySelector('.editable')
        if (editorField) {
          editorField.innerHTML = content
        }
      }
    } else if (targetName === 'title') {
      const titleField = document.getElementById('post_title')
      console.log('[populate-document] Title field found:', !!titleField)
      if (titleField) {
        titleField.value = content.replace(/<[^>]*>?/gm, '')
        this.triggerFieldResize(titleField)
        console.log('[populate-document] Title set to:', titleField.value)
      }
    } else if (targetName === 'description') {
      const descriptionField = document.getElementById('post_description')
      console.log('[populate-document] Description field found:', !!descriptionField)
      if (descriptionField) {
        descriptionField.value = content.replace(/<[^>]*>?/gm, '')
        this.triggerFieldResize(descriptionField)
        console.log('[populate-document] Description set to:', descriptionField.value)
      }
    }
  }

  triggerFieldResize(field) {
    // Trigger resize for auto-expanding textareas
    field.style.height = 'auto'
    field.style.height = field.scrollHeight + 'px'
    // Also dispatch input event to trigger any listeners
    field.dispatchEvent(new Event('input', { bubbles: true }))
  }

  undo() {
    const previousContent = window.quickstartPreviousContent
    if (!previousContent) return

    // Restore title
    const titleField = document.getElementById('post_title')
    if (titleField) {
      titleField.value = previousContent.title
      this.triggerFieldResize(titleField)
    }

    // Restore description
    const descriptionField = document.getElementById('post_description')
    if (descriptionField) {
      descriptionField.value = previousContent.description
      this.triggerFieldResize(descriptionField)
    }

    // Restore body
    if (window.tiptapEditor) {
      window.tiptapEditor.commands.setContent(previousContent.body)
      if (window._syncAndSaveEditor) window._syncAndSaveEditor()
    } else {
      const editorField = document.querySelector('.editable')
      if (editorField) editorField.innerHTML = previousContent.body
    }

    // Reset UI state - hide success, show form
    this.resetToInitialState()

    // Clear the stored content
    window.quickstartPreviousContent = null
  }

  resetToInitialState() {
    // Hide success state
    const successState = document.getElementById('quickstartSuccess')
    if (successState) {
      successState.classList.add('d-none')
      successState.classList.remove('d-block')
    }

    // Show the initial button
    const button = document.getElementById('quickstartButton')
    if (button) {
      button.classList.remove('d-none')
      button.classList.add('d-block')
    }

    // Hide the form (it shows when button is clicked)
    const form = document.getElementById('quickstartForm')
    if (form) {
      form.classList.add('d-none')
      form.classList.remove('d-block')
    }
  }
}
